import { lazy, Suspense } from 'react';

import { getModalStyle } from '@/utils/Modal';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

//import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
//import Button from '@/components/Button';

const Chip = lazy(() => import('@mui/material/Chip'));

import { html } from '@/utils/Format';
import { date } from '@/utils/Dates';

export default function NotificationModal({t, open, setOpen, notification, manage, fullScreen}){

    const { sxDialog/*, sxCloseIcon*/ } = getModalStyle();

    const handleClose = () => setOpen(false);

    return (
        
        <Dialog
            container={fullScreen?.active ? fullScreen?.node?.current : null}
            sx={sxDialog}
            key={'notification_information_'+notification?.id}
            onClose={handleClose} 
            open={open}
            fullWidth={true}
            maxWidth='lg'
        >
            <DialogTitle className='notification-modal-title border-b border-gray-200 !pb-2 !mt-0'>
                <div>
                    {notification?.titulo}
                </div>
                <div className="text-xs text-center">
                    {date(notification?.fecha_publicacion,true)}
                </div>
                {
                    manage &&
                    <div className="text-center">
                        {
                            notification?.roles?.length > 0 ?
                                notification?.roles?.map((role, indexChip) => (
                                    <span key={indexChip}>
                                        <Suspense>
                                            <Chip                                                                 
                                                label={role?.name} 
                                                className="m-1"
                                            />
                                        </Suspense>
                                    </span>
                                ))
                            :
                                <span key={'notification_information_empty_'+notification?.id}>
                                    <Suspense>
                                        <Chip                                                             
                                            /*sx={{
                                                marginX:'2px',
                                                backgroundColor:'rgb(129,0,0,1)',
                                                color:'#FFFFFF',
                                                fontWeight:'bold'
                                            }}*/
                                            label={t('notifications.empty.roles')}
                                            className="m-1"
                                        />
                                    </Suspense>
                                </span>
                        }
                    </div>
                }
            </DialogTitle>
            {/*
            <IconButton                    
                onClick={handleClose}
                sx={sxCloseIcon}
            >
                <CloseIcon />
            </IconButton>
            */}
            <DialogContent className='notification-modal-content'>                
                <div dangerouslySetInnerHTML={{__html: html(notification?.descripcion)}}></div>                
            </DialogContent>
            <div className="modal-buttons">
                <CloseIcon className='action-button-modal text-black' onClick={handleClose}/>
            </div>
        </Dialog>
  );
}